import { ColumnName, ColumnNoc, ColumnExpander} from "components/common/TableColumns"
import { ColumnIntermediate, ColumnIntermediateTime, ColumnRank} from "components/sports/ath/race_road/results/ColumnsLive"
import { ColumnIntermediateRank } from "components/common/TableColumnsIntermediates"
import { ColumnWarnings } from "components/sports/ath/race_road/results/ColumnsLive"
export function TableColumns(columnsAdded) {

    return (
        [
            ColumnIntermediateRank({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnIntermediate({ config: columnsAdded }),
            ColumnIntermediateTime({}),
            ColumnWarnings({}),
            ColumnExpander({ type: 'extendedResults' })
        ]
    )
}

export default TableColumns
